module.exports = __webpack_public_path__ + "img/live01.de04eab9.png";